import React, { useState } from 'react'
import { CCol, CFormInput, CFormLabel } from '@coreui/react-pro'
import ImageDropzone, {
  MAX_IMAGE_SIZE,
  SUPPORTED_IMAGE_FORMATS,
} from 'src/components/common/ImageDropzone'

const BasicSetting = ({ gameName, onGameNameChange, logo, image, onImageChange }) => {
  const [imageError, setImageError] = useState('')

  const handleImageFile = (file) => {
    if (!SUPPORTED_IMAGE_FORMATS.includes(file.type)) {
      setImageError('Invalid file format, only JPG, PNG or WEBP is allowed')
      return
    }
    if (file.size > MAX_IMAGE_SIZE) {
      setImageError('File size too large, max file size is 2 MB')
      return
    }
    setImageError('')
    onImageChange(file)
  }

  return (
    <>
      <CCol md={12}>
        <CFormLabel className="fw-bold" htmlFor="game_name">
          Game Name*
        </CFormLabel>

        <CFormInput
          id="game_name"
          value={gameName || ''}
          name="game_name"
          onChange={(event) => onGameNameChange(event.target.value)}
        />
        <small>
          <i> ({`Ex: ABC Fantasy 2023-24`})</i>
        </small>
      </CCol>

      <CCol md={12}>
        <CFormLabel className="fw-bold">Game Logo</CFormLabel>
        <ImageDropzone
          minHeight={120}
          previewSize={100}
          file={image}
          existingUrl={logo ? `${process.env.REACT_APP_API_URL}uploads/game_logo/${logo}` : null}
          error={imageError}
          onChange={handleImageFile}
        />
      </CCol>
    </>
  )
}

export default BasicSetting
